import {createSelector} from 'reselect';
import attributes from '../../tracking/attributes';
import getCurrencyCode from '../../utils/getCurrencyCode';
import {isEmailRequired} from '../GuestSelectors';
import {
  getContactNumber, getCurrency, getEmailAddress, getSelectedDeliveryCountry, selectIsContactNumberRequired,
} from '../selectors';

export const getPaymentOptions = state => state.payment.options;
export const getMarketingPreferences = state => state.email.optedIntoMarketing;

export const getStoredCV2Details = state => state.payment.storedCV2Details;
export const getLegacyKlarnaDetails = state => state.payment.klarnaDetails;

// Optional Consent
export const getOptionalPaymentDetailsConsentConfiguration = state => state.payment.optionalPaymentDetailsConsentConfiguration;

export const isKCPCreditCardAvailable = createSelector(
  [getPaymentOptions],
  paymentOptions => paymentOptions.some(option => option.name === 'ADYEN-kcp_creditcard' || option.name === 'KCP_CARD'),
);

export const isGooglePayInPaymentsOptionList = createSelector(
  [getPaymentOptions],
  paymentOptions => paymentOptions.some(option => option.type === 'GOOGLEPAY'),
);

export const getMarketingPreferencesTrackingAttributes = createSelector(
  [getMarketingPreferences],
  selectedMarketingPreference => attributes.getAttribute(
    'marketingPreference',
    `${selectedMarketingPreference}`,
  ),
);

export const getContactNumberRequiredTrackingAttributes = createSelector(
  [selectIsContactNumberRequired],
  isRequired => ({name: 'isContactNumberRequired', value: isRequired}),
);

export const getEmailTrackingAttributes = createSelector(
  [getEmailAddress, isEmailRequired],
  (email, emailRequired) => {
    let emailLength;
    if (email) {
      emailLength = email.length;
    } else if (email === null) {
      emailLength = 'null';
    } else if (email === undefined) {
      emailLength = 'undefined';
    } else {
      emailLength = 'empty';
    }
    
    const emailHasAtSymbol = email ? email.includes('@') : false;
    
    return [
      {name: 'emailRequired', value: emailRequired},
      {name: 'emailLength', value: emailLength},
      {name: 'emailHasAtSymbol', value: emailHasAtSymbol},
    ];
  },
);

export const getContactNumberLengthTrackingAttributes = createSelector(
  [getContactNumber],
  contactNumber => ({name: 'contactNumberLength', value: contactNumber?.length || 0}),
);

export const getDeliveryCountryCurrency = createSelector(
  [getSelectedDeliveryCountry],
  getCurrencyCode,
);

export const deliveryCountryOrderCurrencyMatch = createSelector(
  [getDeliveryCountryCurrency, getCurrency],
  (selectedDeliveryCountryCurrency, orderCurrency) => selectedDeliveryCountryCurrency === orderCurrency,
);
